import _implicitStylesheets from "./headerMenuItem.css";
import _implicitScopedStylesheets from "./headerMenuItem.scoped.css?scoped=true";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<div class="slds-size_1-of-1${0}"${2}><a${"a1:data-testid"}${"a1:data-active"} data-menu="item" role="menuitem" class="menu-item${0}" tabindex="-1"${2}>${"t2"}</a></div>`;
function tmpl($api, $cmp, $slotset, $ctx) {
  const {b: api_bind, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment} = $api;
  const {_m0} = $ctx;
  return [api_static_fragment($fragment1, 1, [api_static_part(1, {
    on: {
      "click": _m0 || ($ctx._m0 = api_bind($cmp.onClick))
    },
    attrs: {
      "data-testid": $cmp.props.name,
      "data-active": $cmp.props.active
    }
  }, null), api_static_part(2, null, api_dynamic_text($cmp.props.name))])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-146ks616lib";
tmpl.legacyStylesheetToken = "appx-headerMenuItem_headerMenuItem";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
